import { OnlineSpeakingMonitoringResult, OnlineSpeakingMonitoringType } from 'api';
import { FilterOption } from '@britishcouncil/react-admin';
import {
  getOnlineSpeakingMonitoringResultName,
  getOnlineSpeakingMonitoringTypeName,
} from './onlineSpeakingMonitoringHelpers';

export const ONLINE_SPEAKING_MONITORING_TYPE_OPTIONS: FilterOption<OnlineSpeakingMonitoringType>[] =
  Object.values(OnlineSpeakingMonitoringType)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      text: getOnlineSpeakingMonitoringTypeName(value),
      value: value,
    }));

export const ONLINE_SPEAKING_MONITORING_RESULT_OPTIONS: FilterOption<OnlineSpeakingMonitoringResult>[] =
  Object.values(OnlineSpeakingMonitoringResult)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      text: getOnlineSpeakingMonitoringResultName(value),
      value: value,
    }));

export const VALID_ONLINE_SPEAKING_MONITORING_TYPES = ONLINE_SPEAKING_MONITORING_TYPE_OPTIONS.map(
  (option) => option.value
);

export const VALID_ONLINE_SPEAKING_MONITORING_RESULTS =
  ONLINE_SPEAKING_MONITORING_RESULT_OPTIONS.map((option) => option.value);
